<template>
  <section class="ew-bg-gray">
    {{addEventPixeleFacebook()}}
    <div class="ew-navbar ew-white p-3 ew-mb">
      <router-link to="/shipments" class="btn btn-lg btn-white text-dark">
        <img src="@/assets/images/back-arrow.png" alt=""> Cancelar
      </router-link>
    </div>
  <section>
    <div class="ew-smaller-container ew-mb">
      <div class="ew-loading" v-if="isLoading">
        <span class="ew-spinner"></span>
        <p class="ew-loading-text">Cargando resumen de compra…</p>
      </div>

      <template v-else>
        <div class="alert alert-warning" role="alert" v-if="isPaymentGuide">
          <h4 class="alert-heading">Estimado usuario!</h4>
          <p>En este momento no contamos con guias disponible para este tipo servicio.</p>
        </div>

        <div class="ew-card ew-summary-card">
          <p class="ew-card-title">Resumen de compra</p>
          <div class="ew-summary-detail">
            <div class="ew-summary-row">
              <span>Destino</span>
              <span>{{ shipment.destination_direction.full_name }}, {{ shipment.destination_direction.address }}<br>C.P. {{ shipment.destination_direction.postal_code }}</span>
            </div>
            <div class="ew-summary-row">
              <span>Servicio</span>
              <span>{{ shipment.selected_service.carrier_service_name }}</span>
            </div>
            <div class="ew-summary-total"><span>Total</span><span>{{ shipment.selected_service.currency }} {{ formatMXN(shipment.selected_service.total_amount) }}</span></div>
          </div>
        </div>

        <div class="ew-card">
          <p class="ew-card-title">Método de pago</p>
          <form @submit.prevent>
            <div class="ew-pay-options">
              <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal' }">
                <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'paypal'">
                <img class="ew-pay-option__logo" src="@/assets/images/paypal.png" alt="">
                <span class="ew-pay-option__label">PayPal</span>
              </label>

              <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'oxxo' }">
                <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'oxxo'">
                <img class="ew-pay-option__logo" src="@/assets/images/oxxopay_brand.png" alt="">
                <span class="ew-pay-option__label">OXXO</span>
              </label>
            </div>

            <div class="ew-pay-actions">
              <a :href="paypalLink" class="ew-btn-primary" v-if="paypalLink !== '' && paymentMethod === 'paypal'">Pagar</a>

              <button type="button" class="ew-btn-primary" v-if="paymentMethod === 'oxxo'" v-on:click="paymentOXXO" :disabled="payDisabled">Pagar</button>
            </div>
            <div class="ew-field-error" v-if="paymentError">{{ paymentError }}</div>
          </form>
        </div>
      </template>
    </div>
  </section>
  </section>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import commons from '../commons'
import { formatMXN } from '../commons/currency'

export default {
  name: 'PaymentDetails',
  data () {
    return {
      paypalLink: '',
      shipmentId: null,
      shipment: null,
      isLoading: true,
      paymentMethod: 'paypal',
      isPaymentGuide:false,
      payDisabled:false,
      paymentError:''
    }
  },
  created () {
    this.getUser();
    console.log(this.user)
    this.shipmentId = this.$route.params.id
    this.getShipment(this.shipmentId)
      .then(response => {
        this.shipment = response.data
        axios.post(`${commons.apiURL}/api/v1/payments/${this.shipmentId}?email=${this.user.email}`)
          .then(response => {
            if (response.status === 204) {
              this.isPaymentGuide = true;
            } else {
              this.paypalLink = response.data.url  
            }
          })
        this.isLoading = false
      })
      .catch(error => {
        console.error(error)
      })
  },
  methods: {
    formatMXN,
    addEventPixeleFacebook(){
      fbq('track', 'InitiateCheckout');
    },
    paymentOXXO(){
      if ("oxxo" === this.paymentMethod) {
        this.payDisabled = true;
        this.paymentError = '';
        axios.post(`${commons.apiURL}/api/v1/payments/conekta/oxxo/${this.shipmentId}`, {email:this.user.email}).then(response => {
            if (response.data.message === "ok") {
               this.$router.push({ path: '/payments/result/success', query: { oxxo: 'true',reference:response.data.reference, email:this.user.email }})
            }else{
              this.payDisabled = false;
              this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
            }
        }).catch(() => {
          this.payDisabled = false;
          this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
        })
      }
    },
    getShipment (id) {
      const url = `${commons.apiURL}/api/v1/shipments/${id}`
      return axios.get(url)
    },
    pay (paymentMethod) {
      let myWindow = null
      if (paymentMethod === 'paypal') {
        axios.post(`${commons.apiURL}/api/v1/payments/${this.shipmentId}`)
          .then(response => {
            myWindow = window.open(response.data.url, 'Moovet - PayPal', 'centerscreen,modal')
            myWindow.focus()
          })
      }
    },
     ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted(){
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/variables";
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 450px; margin: 0 auto; }

.ew-navbar {
  .btn {
    font-size: 1.5rem;
  }
}

.ew-mb{
  margin-bottom: 5rem;
}

.ew-card { @include ew-card; padding: 1.5rem 1.75rem; margin-bottom: 1.25rem; }
.ew-card-title { @include ew-card-title; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-summary-card { @include ew-summary-card; }
.ew-summary-row { @include ew-summary-row; }
.ew-summary-total { @include ew-summary-total; }

.ew-loading { @include ew-loading; }
.ew-spinner { @include ew-spinner; }
.ew-loading-text { @include ew-loading-text; }

.ew-pay-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}
.ew-pay-option { @include ew-pay-option; }

.ew-pay-actions {
  display: flex;
  justify-content: flex-end;

  .ew-btn-primary { width: 100%; height: 3rem; text-decoration: none; text-align: center; }
}

.ew-field-error { @include ew-field-error; }
</style>



// WEBPACK FOOTER //
// src/components/PaymentDetails.vue